import { Image, type ImageProps } from '@chakra-ui/react'
import React from 'react'
import BlueprintBLogo from './assets/blueprint_b_logo.png'

export const BlueBLogo = (props: ImageProps) => {
  return (
    <Image
      alt="logo"
      src={BlueprintBLogo}
      width="32px"
      height="32px"
      loading="eager"
      objectFit="contain"
      {...props}
    />
  )
}
